import { useQuery } from "@tanstack/react-query";

import { useRosterFeeAdjustmentRequests } from "../../fee-adjustment";
import { fetchCustomerQuoteFeeAdjustmentContext } from "../repo";

/** 为报价直达和带名单参数的入口恢复同一费用账本读取链路。 */
export function useCustomerQuoteFeeAdjustments(
  customerQuoteId: string,
  explicitContext?: { orderId: string; rosterId: string },
  enabled = true,
) {
  const contextQuery = useQuery({
    queryKey: ["customerQuoteFeeAdjustmentContext", customerQuoteId],
    queryFn: () => fetchCustomerQuoteFeeAdjustmentContext(customerQuoteId),
    enabled: enabled && Boolean(customerQuoteId) && !explicitContext,
  });
  const context = explicitContext ?? contextQuery.data;
  const recordsQuery = useRosterFeeAdjustmentRequests(
    context?.rosterId ?? "",
    enabled && Boolean(context?.rosterId),
    customerQuoteId,
  );
  return {
    context,
    data: recordsQuery.data,
    isLoading: (!explicitContext && contextQuery.isLoading) || recordsQuery.isLoading,
    isError: (!explicitContext && contextQuery.isError) || recordsQuery.isError,
    isRetrying: contextQuery.isFetching || recordsQuery.isFetching,
    retry: async () => {
      if (!explicitContext && (!context || contextQuery.isError)) {
        // 名单解析恢复后由查询依赖自动读取账本，避免向旧名单重发请求。
        await contextQuery.refetch();
      } else if (context?.rosterId) {
        await recordsQuery.refetch();
      }
    },
  };
}
